import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCitiesByRegion } from 'shared/services/fetchCitiesByRegion';
import { ISelectRegionActionPayload } from 'shared/slices/geo/types';
import { updateRegion } from 'shared/thunks/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { updatePromoSearchTypes } from 'shared/thunks/promoSearchTypes';
import { TLocation } from 'shared/types/location';
import { IThunkApi } from 'shared/types/redux';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const selectRegion = createAsyncThunk<ISelectRegionActionPayload, TLocation, IThunkApiExtended>(
  'geo/locationSwitcher/selectRegion',
  async (location, thunkApi) => {
    const { extra: context, rejectWithValue, dispatch } = thunkApi;

    if (location === 'moscow_mo' || location === 'spb_lo') {
      dispatch(updateRegion(location));
      dispatch(updatePromoSearchTypes(location));
      dispatch(updateSearchMeta());

      return { region: location, cities: [] };
    }

    try {
      const cities = await fetchCitiesByRegion(context, { regionId: location.id });

      dispatch(updateRegion(location));
      dispatch(updatePromoSearchTypes(location));
      dispatch(updateSearchMeta());

      return { region: location, cities };
    } catch (e) {
      console.error(e);

      return rejectWithValue();
    }
  },
);
